<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="dialogVisible"
        center
        ref="dialog"
        width="400px"
    >
        <div class="warning-text text-center">
            <i class="mdi mdi-alert-circle"></i> You have been logged out due to
            inactivity.
        </div>
        <div class="dialog-footer" slot="footer">
            <el-button @click="login()" type="primary"> Login </el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
        };
    },
    methods: {
        show() {
            this.dialogVisible = true;
        },
        login() {
            location = "/login";
        },
    },
};
</script>
